<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  inboxes: { type: Array, default: () => [] },
  modelValue: {
    type: Object,
    default: () => ({ inboxId: undefined, state: 'needs_reply' }),
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const STATE_OPTIONS = [
  { value: 'needs_reply', label: 'NEEDS_REPLY' },
  { value: 'all', label: 'ALL' },
  { value: 'hidden', label: 'HIDDEN' },
];

const selectClass =
  'h-8 px-2 text-sm border rounded-lg border-n-weak bg-n-solid-2 text-n-slate-12';

const handleStateChange = event => {
  emit('update:modelValue', {
    ...props.modelValue,
    state: event.target.value,
  });
};

const handleInboxChange = event => {
  const { value } = event.target;
  emit('update:modelValue', {
    ...props.modelValue,
    inboxId: value ? Number(value) : undefined,
  });
};
</script>

<template>
  <div class="flex items-center gap-2 px-4 py-3 border-b border-n-weak">
    <select
      data-testid="comments-filter-state"
      :class="selectClass"
      :value="modelValue.state"
      @change="handleStateChange"
    >
      <option
        v-for="option in STATE_OPTIONS"
        :key="option.value"
        :value="option.value"
      >
        {{ t(`COMMENTS.FILTERS.STATE.${option.label}`) }}
      </option>
    </select>
    <select
      data-testid="comments-filter-inbox"
      :class="selectClass"
      :value="modelValue.inboxId ?? ''"
      @change="handleInboxChange"
    >
      <option value="">{{ t('COMMENTS.FILTERS.INBOX.ALL_INBOXES') }}</option>
      <option v-for="inbox in inboxes" :key="inbox.id" :value="inbox.id">
        {{ inbox.name }}
      </option>
    </select>
  </div>
</template>
